export enum FilterIdEnum {
  DATE = 'date',
  REALTIME = 'realtime',

  LANG = 'lang',
  DEVICE = 'device',
  STORE = 'store',
  CATALOG = 'catalog',

  COMPARE = 'compare',

  ENABLED = 'enabled',
  ACTIVE = 'active',

  AUDIT_OBJECT_TYPE = 'objectType',
  AUDIT_ACTION = 'action'
}
